// The mobile app shows the website's legal pages inside itself, opening them
// with ?view=app (tracker ticket T&P-34, 19 Oct 2026). Such a page shows
// alone, without the site's header and footer, whose links lead around the
// website. The choice is kept for the visit, so a link from one legal page
// to another stays inside the app's view too.

export const APP_VIEW_KEY = "tp.appView";

/**
 * Whether this visit is the app's view. `search` is the address's query
 * ("?view=app"); `storage` is sessionStorage, or null where it is blocked
 * (the page then decides from the address alone).
 */
export function isAppView(search, storage) {
  const asked = new URLSearchParams(search).get("view") === "app";
  try {
    if (asked) storage?.setItem(APP_VIEW_KEY, "1");
    return asked || storage?.getItem(APP_VIEW_KEY) === "1";
  } catch {
    // Storage refused (private mode): the address alone decides.
    return asked;
  }
}

/** sessionStorage, or null where the browser refuses it. */
export function visitStorage() {
  try {
    return window.sessionStorage;
  } catch {
    return null;
  }
}
